import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Card, GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Field, FieldArrayRenderProps } from "@progress/kendo-react-form";
import FormTextField from "../../components/formFields/FormTextField";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { Typography } from "@progress/kendo-react-common";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
// import { FaRegEye } from "react-icons/fa";
// import { MdDelete } from "react-icons/md";
// import FormImageUpload from "../../components/formFields/FormImageUpload";
// import { LoadingPanel } from "../../components/layout/Loading";

import { ErrorToast } from "../../components/toast/Toasts";
import {
  htmlIdValidator,
  requiredValidator,
  skipValidator,
} from "../../components/formFields/CommonValidator";

import { setDeleteImageIndex } from "./cmsSlice";
import {
  DeleteImage,
  getCMSByID,
  // ImageNameIsAvailabel,
  InsertImage,
  UpdateImage,
} from "./services/cms.services";
// import { debounce } from "lodash";
import { useLocation } from "react-router-dom";
import FormImageUpload from "../../components/formFields/FormImageUpload";
import { MdDelete } from "react-icons/md";
// import { RiImageAddLine, RiImageEditFill } from "react-icons/ri";
// import { INVALID_ID_NAME, REQUIRED_FIELD } from "../../_contstants/Messages";

const CMSImageArray = (fieldArrayRenderProps: FieldArrayRenderProps) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  // const gridRef = useRef<any>(null);

  const DeleteImageIndex = useAppSelector(
    (state) => state.cms.DeleteImageIndex
  );
  const CMSID = location.state?.CMSID;
  // const loading = useAppSelector((state) => state.cms.loading);

  const dialogName = useAppSelector((state) => state.dialog.dialogName);

  const pushElementInarray = React.useCallback(() => {
    fieldArrayRenderProps.onPush({
      value: {
        Name: "",
        AltName: "",
        Image: "",
      },
    });
  }, [fieldArrayRenderProps]);

  const handleImageSave = async (index: number) => {
    const ImageIndex = fieldArrayRenderProps?.value[index];
    const ID = ImageIndex?.ID;
    const Name = ImageIndex?.Name;
    const AltName = ImageIndex?.AltName;
    const Image = ImageIndex?.Image;
    const ImageData = new FormData();
    if (!Name) return ErrorToast("Please Enter Name!");

    let binaryPhoto = "";
    if (typeof Image !== "string") {
      binaryPhoto = Image[0]?.getRawFile();
    }
    ImageData.append("Image", binaryPhoto);
    ImageData.append("AltName", AltName);
    ImageData.append("Name", Name);
    ImageData.append("CMSID", CMSID);
    if (ID) {
      ImageData.append("ID", ID);
      const res = await dispatch(UpdateImage(ImageData));
      if (res?.meta?.requestStatus === "fulfilled") {
        dispatch(getCMSByID(CMSID));
      }
    } else {
      const res = await dispatch(InsertImage(ImageData));
      if (res?.meta?.requestStatus === "fulfilled") {
        dispatch(getCMSByID(CMSID));
      }
    }
  };

  // const handleOpenImage = (url: string) => {
  //   if (url && typeof url === "string") {
  //     window.open(url);
  //   }
  // };

  const handleOpenDeleteDialog = (index: number) => {
    dispatch(openDialog("delete-cms-image"));
    dispatch(setDeleteImageIndex(index));
  };
  const handleDeleteAction = React.useCallback(
    async (index: number) => {
      const ID = fieldArrayRenderProps?.value[index]?.ID;
      if (ID) {
        const response = await dispatch(DeleteImage(ID));
        if (response?.meta?.requestStatus === "fulfilled") {
          fieldArrayRenderProps?.onRemove({ index: index });
          dispatch(closeDialog());
          dispatch(setDeleteImageIndex(-1));
        }
      } else {
        fieldArrayRenderProps.onRemove({ index: index });
        dispatch(closeDialog());
        dispatch(setDeleteImageIndex(-1));
      }
    },
    [fieldArrayRenderProps]
  );

  // console.log(fieldArrayRenderProps?.value)

  // const debouncedHandleAlreadyExist = useCallback(
  //   debounce(
  //     async (e: any, index: number, formRenderProps: FormRenderProps) => {
  //       if (e?.value) {
  //         const isValid = /^[A-Za-z_][A-Za-z0-9\-:._]{3,}$/.test(e.value);
  //         if (isValid) {
  //           const res = await dispatch(ImageNameIsAvailabel(e?.value));
  //           if (res.meta.requestStatus === "fulfilled") {
  //             formRenderProps.onChange(`Images.${index}.IsValidName`, {
  //               value: res?.payload?.IsAlreadyExist,
  //             });
  //           }
  //         }
  //       }
  //     },
  //     500
  //   ),
  //   []
  // );

  // const handleAlreadyExist = async (
  //   e: any,
  //   index: number,
  //   formRenderProps: FormRenderProps
  // ) => {
  //   debouncedHandleAlreadyExist(e, index, formRenderProps);
  // };

  return (
    <>
      {/* {loading && <LoadingPanel gridRef={gridRef} />} */}
      {/* {fieldArrayRenderProps?.value?.length < 1 ? pushElementInarray() : null} */}
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 10px",
          }}
        >
          <Typography.h4>Images Upload</Typography.h4>

          <Button
            fillMode={"solid"}
            themeColor={"primary"}
            onClick={pushElementInarray}
            type="button"
          >
            Add New Image
          </Button>
        </GridLayoutItem>
        {dialogName === "delete-cms-image" && (
          <AppDialog>
            <>
              <Typography.h5>{"Delete Image"}</Typography.h5>
              <GridLayout>
                <GridLayoutItem>
                  <Typography.p>
                    Are you sure you want to delete this?
                  </Typography.p>
                </GridLayoutItem>
                <GridLayoutItem
                  style={{
                    display: "flex",
                    justifyContent: "end",
                  }}
                >
                  <DialogCloseButton themeColor="error" />
                  <Button
                    fillMode={"solid"}
                    themeColor={"error"}
                    onClick={() => handleDeleteAction(DeleteImageIndex)}
                    type="button"
                  >
                    Delete
                  </Button>
                </GridLayoutItem>
              </GridLayout>
            </>
          </AppDialog>
        )}
        <GridLayoutItem>
          <GridLayout
            style={{ marginRight: 20 }}
            cols={[{ width: "50%" }, { width: "50%" }]}
            gap={{ rows: 0, cols: 10 }}
          >
            {fieldArrayRenderProps.value &&
              fieldArrayRenderProps.value.length > 0 &&
              fieldArrayRenderProps.value.map((Images: any, index: number) => (
                <GridLayoutItem key={index}>
                  <Card className="fieldarray-card-imageArray">
                    <GridLayout
                      style={{ marginRight: 20, padding: 10 }}
                      gap={{ rows: 0, cols: 10 }}
                      cols={[
                        { width: "40%" },
                        { width: "40%" },
                        { width: "20%" },
                      ]}
                    >
                      <GridLayoutItem colSpan={3}>
                        <Field
                          imageWidth={60}
                          imageHeight={60}
                          name={`Images.${index}.Image`}
                          // label="Image"
                          type="file"
                          accept="image/*"
                          acceptFileTypesMessage="Only JPG, PNG, and WEBP images are accepted."
                          component={FormImageUpload}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem colSpan={3} className="d-flex gap-2">
                        <Field
                          wrapperClassName="w-100"
                          name={`Images.${index}.Name`}
                          label="Name"
                          placeholder="i.e. home-banner-b"
                          disabled={fieldArrayRenderProps.value?.[index].ID}
                          component={FormTextField}
                          // onChange={(e) =>
                          //   handleAlreadyExist(
                          //     e,
                          //     index,
                          //     fieldArrayRenderProps.formRenderProps
                          //   )
                          // }
                          validator={
                            fieldArrayRenderProps.value?.[index].Image &&
                            (Array.isArray(
                              fieldArrayRenderProps.value[index].Image
                            )
                              ? fieldArrayRenderProps.value[index].Image
                                  .length > 0
                              : fieldArrayRenderProps.value[
                                  index
                                ].Image.trim() !== "")
                              ? htmlIdValidator
                              : skipValidator
                          }
                          astrike={
                            fieldArrayRenderProps.value?.[index].Image &&
                            (Array.isArray(
                              fieldArrayRenderProps.value[index].Image
                            )
                              ? fieldArrayRenderProps.value[index].Image
                                  .length > 0
                              : fieldArrayRenderProps.value[
                                  index
                                ].Image.trim() !== "")
                              ? true
                              : false
                          }
                        />
                        {/* </GridLayoutItem>
                      <GridLayoutItem> */}
                        <Field
                          wrapperClassName="w-100"
                          name={`Images.${index}.AltName`}
                          label="Alt Name"
                          placeholder="i.e. Banner Image"
                          validator={
                            fieldArrayRenderProps.value?.[index].Image &&
                            (Array.isArray(
                              fieldArrayRenderProps.value[index].Image
                            )
                              ? fieldArrayRenderProps.value[index].Image
                                  .length > 0
                              : fieldArrayRenderProps.value[
                                  index
                                ].Image.trim() !== "")
                              ? requiredValidator
                              : skipValidator
                          }
                          astrike={
                            fieldArrayRenderProps.value?.[index].Image &&
                            (Array.isArray(
                              fieldArrayRenderProps.value[index].Image
                            )
                              ? fieldArrayRenderProps.value[index].Image
                                  .length > 0
                              : fieldArrayRenderProps.value[
                                  index
                                ].Image.trim() !== "")
                              ? true
                              : false
                          }
                          component={FormTextField}
                        />
                        {/* </GridLayoutItem>
                      <GridLayoutItem> */}
                        <div
                          style={{
                            marginTop: 34,
                            display: "flex",
                            justifyContent: "end",
                            gap: 10,
                          }}
                        >
                          <Button
                            type="button"
                            fillMode={"solid"}
                            themeColor={"primary"}
                            title={
                              !fieldArrayRenderProps.value[index]?.ID
                                ? "Add Image"
                                : "Update Image"
                            }
                            style={{ width: "100%" }}
                            onClick={() => handleImageSave(index)}
                            disabled={
                              fieldArrayRenderProps.value[index]?.Image
                                ?.length < 1 ||
                              typeof fieldArrayRenderProps.value[index]
                                ?.Image === "string" ||
                              !fieldArrayRenderProps.value[index]?.Name ||
                              !fieldArrayRenderProps.value[index]?.AltName
                                ? true
                                : false
                            }
                          >
                            {!fieldArrayRenderProps.value[index]?.ID
                              ? "Save"
                              : "Update"}
                          </Button>
                          {false && (
                            <Button
                              onClick={() => handleOpenDeleteDialog(index)}
                              // disabled={fieldArrayRenderProps.value.length === 1}
                              title={"Delete Image"}
                              fillMode={"solid"}
                              themeColor={"error"}
                              type="button"
                              size={"small"}
                              // style={{ width: 32, height: 32 }}
                            >
                              <MdDelete className="absolute-position fs-5" />
                            </Button>
                          )}
                        </div>
                      </GridLayoutItem>
                    </GridLayout>
                  </Card>
                </GridLayoutItem>
              ))}
          </GridLayout>
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

export default CMSImageArray;
